module.exports = window["core-js/modules/es.object.values.js"];